import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageTitle, statusColor } from "@/components/DashUI";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { toast } from "sonner";
import { CheckCircle2, AlertTriangle } from "lucide-react";

const TYPE_LABELS = {
  agent_approval: "Agent Approval", provider_approval: "Provider Approval",
  provider_agreement_approval: "Provider Agreement", commission_configuration_approval: "Commission Config",
  commission_payout_approval: "Commission Payout / Placement", duplicate_lead_dispute: "Duplicate Lead Dispute",
  compliance_flag: "Compliance Flag", privacy_security_issue: "Privacy / Security",
  unusual_placement: "Unusual Placement", customer_dispute: "Customer Dispute",
};

export default function Exceptions() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("OPEN");
  const load = () => api.get("/admin/exceptions", { params: { status: filter } }).then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [filter]);

  const resolve = async (id) => { await api.patch(`/admin/exceptions/${id}`, { status: "RESOLVED", note: "Resolved by admin" }); toast.success("Resolved"); load(); };

  return (
    <div>
      <PageTitle title="Exception Queue" subtitle="Concentrate human review here — everything else automates">
        <Tabs value={filter} onValueChange={setFilter}>
          <TabsList><TabsTrigger value="OPEN" data-testid="ex-tab-open">Open</TabsTrigger><TabsTrigger value="ALL" data-testid="ex-tab-all">All</TabsTrigger></TabsList>
        </Tabs>
      </PageTitle>
      <div className="space-y-3">
        {items.map((it) => (
          <Card key={it.id} className="flex flex-col gap-3 p-5 sm:flex-row sm:items-center sm:justify-between" data-testid={`exception-${it.id}`}>
            <div className="flex items-start gap-3">
              <AlertTriangle className={`mt-0.5 h-5 w-5 ${it.type === "compliance_flag" ? "text-amberbrand" : "text-clinical"}`} />
              <div>
                <div className="flex items-center gap-2">
                  <Badge variant="secondary" className="text-[10px]">{TYPE_LABELS[it.type] || it.type}</Badge>
                  <Badge className={`${statusColor(it.status)} hover:${statusColor(it.status)} text-[10px]`}>{it.status}</Badge>
                </div>
                <p className="mt-1.5 font-medium text-navy">{it.title}</p>
                <p className="text-sm text-slate-500">{it.detail}</p>
              </div>
            </div>
            {it.status === "OPEN" && (
              <Button size="sm" data-testid={`ex-resolve-${it.id}`} onClick={() => resolve(it.id)} className="bg-emeraldbrand hover:bg-emeraldbrand/90">
                <CheckCircle2 className="mr-1.5 h-4 w-4" /> Resolve
              </Button>
            )}
          </Card>
        ))}
        {items.length === 0 && <Card className="p-10 text-center text-slate-400">No exceptions. The system is running smoothly.</Card>}
      </div>
    </div>
  );
}
